<template>
    <div>
        <label
            v-if="label"
            class="poppinsMedium ppv2-text-black ppv2-mb-2 ppv2-block"
            :style="{ fontSize: labelSize ? `${labelSize}px` : '14px' }"
        >
            {{ label }}
        </label>
        <div :class="['toggle-button-container', containerClass]" :style="containerStyle">
            <button
                v-for="(option, idx) in options"
                :key="idx"
                type="button"
                :class="[
                    'toggle-option',
                    modelValue === option.value ? 'poppinsMedium active' : 'poppinsRegular',
                    customToggleOptionClass,
                ]"
                :style="modelValue === option.value ? activeStyle : {}"
                @click="$emit('update:modelValue', option.value)"
            >
                {{ option.label }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SegmentedControl',
    model: {
        prop: 'modelValue',
        event: 'update:modelValue',
    },
    props: {
        modelValue: {
            type: [String, Number, Boolean],
            default: null,
        },
        options: {
            type: Array,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        labelSize: {
            type: Number,
            default: 14,
        },
        activeColor: {
            type: String,
            default: '#7d2dbd',
        },
        activeTextColor: {
            type: String,
            default: 'white',
        },
        containerClass: {
            type: String,
            default: '',
        },
        containerStyle: {
            type: Object,
            default: () => ({}),
        },
        customToggleOptionClass: {
            type: String,
            default: '',
        },
    },
    emits: ['update:modelValue'],
    computed: {
        activeStyle() {
            return {
                backgroundColor: this.activeColor,
                color: this.activeTextColor,
                boxShadow: `0 4px 12px ${this.activeColor}40`,
            }
        },
    },
}
</script>

<style scoped>
.toggle-button-container {
    display: flex;
    background-color: #7d2dbd1a;
    border-radius: 12px;
    padding: 0;
    width: 100%;
    margin-bottom: 1.375rem;
}

.toggle-option {
    flex: 1;
    padding: 10px 15px;
    border-radius: 10px;
    border: none;
    background-color: transparent;
    color: #94a3b8;
    font-size: clamp(12px, 0.78vw, 14px);
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    outline: none;
    text-align: center;
    white-space: nowrap;
}

.toggle-option:hover:not(.active) {
    color: v-bind(activeColor);
}

.toggle-option.active {
    /* Styles are mostly handled by :style to allow props */
}
</style>
